/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import "intersection-observer";
import "normalize.css";
import React from "react";
import { createRoot } from "react-dom/client";

import AppRoutes from "~/setup/AppRoutes";
import ContextProviders from "~/setup/ContextProviders";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <ContextProviders>
      <AppRoutes />
    </ContextProviders>
  </React.StrictMode>,
);
